import React from "react";
import Logo from "../assets/shiva_bajaj_logo.jpg";
const Navbar = ({ setActiveTab, activeTab }) => {
  return (
    <nav className='bg-white shadow-md text-black'>
      <div className='container mx-auto flex items-center justify-between'>
        {/* Left side logo */}
        <div className='container mx-auto flex items-center justify-center'>
          {/* Centered Logo */}
          <div className='flex items-center'>
            <img
              src={Logo} // replace with your logo path
              alt='Logo'
              className='h-[100px] w-auto bg-white p-2 rounded-full' // Adjust the logo size
            />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
